import { createActions } from 'redux-actions';

const actions = createActions({
  GET_DATA: {
    FINISHED: undefined
  }
})

const configuration = {
  name: 'finished',
  action: actions,
  sagas: undefined,
  reducers: {
    reducer: (state, action) => ({
      ...state,
      isFetchingUserData: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/getDataFinished.js